import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { PORTFOLIO, PORTFOLIO_FILTERS } from "@/lib/site";

export const Portfolio = () => {
  const [active, setActive] = useState("All");
  const list = active === "All" ? PORTFOLIO : PORTFOLIO.filter((p) => p.category === active);

  return (
    <section id="portfolio" className="py-24 lg:py-32 bg-slate-50" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-purple">Featured work</div>
            <h2 className="section-heading text-3xl sm:text-4xl lg:text-5xl mt-3 text-slate-900">
              Selected <span className="text-gradient">projects</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="portfolio-filters">
            {PORTFOLIO_FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                data-testid={`portfolio-filter-${f.toLowerCase()}`}
                className={`text-xs font-semibold px-4 py-2 rounded-full border transition-all ${
                  active === f
                    ? "bg-slate-900 text-white border-slate-900"
                    : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p, i) => (
            <div
              key={p.title + i}
              className="group relative rounded-2xl overflow-hidden bg-white border border-slate-100 card-lift card-tilt reveal"
              style={{ transitionDelay: `${(i % 3) * 70}ms` }}
              data-testid={`portfolio-card-${i}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.alt || p.title}
                  loading="lazy"
                  width="1200"
                  height="900"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="text-[11px] uppercase tracking-widest font-semibold text-brand-purple">{p.category}</div>
                <div className="font-heading font-bold text-lg text-slate-900 mt-1">{p.title}</div>
                <div className="mt-3 flex items-center justify-between">
                  <div className="flex flex-wrap gap-1.5">
                    {p.tags.map((t) => (
                      <span key={t} className="text-[10px] font-semibold px-2 py-1 rounded-full bg-slate-100 text-slate-700">{t}</span>
                    ))}
                  </div>
                  <a href="#contact" className="inline-flex items-center gap-1 text-xs font-semibold text-slate-900 hover:text-brand-purple" data-testid={`portfolio-preview-${i}`}>
                    Live Preview <ExternalLink className="w-3 h-3" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
